module.exports = __webpack_public_path__ + "img/04r-Shop_651.5ebc969b.jpg";